export default __webpack_public_path__ + "static/media/flavors.06a4c420.jpeg";